import { combineEpicsAndCatchErrors } from "../../generic/redux/CombineEpicsAndCatchErrors";

import { ExecuteQueryEpic } from "./analytics/ExecuteQueryEpic";
import { StackPacksEpic } from "./entities/stackPacks/StackPacksEpic";
import { MergeViewParamsEpic } from "./route/MergeViewParamsEpic";
import { SessionEpic } from "./session/CheckSessionEpic";
import {
	UsageGoogleTagManagerEpic,
	UsagePushEventsToGTMDataLayer,
	UsagePushPathChangeToGTMDataLayer,
} from "./usage-track/UsageGoogleTagManagerEpic";
import { UsageTrackPendoIOEpic } from "./usage-track/UsageTrackPendoEpic";
import { TimelineEpic } from "./view/timeline/TimelineEpic";

export const RootEpic = combineEpicsAndCatchErrors(
	SessionEpic,
	StackPacksEpic,
	ExecuteQueryEpic,
	TimelineEpic,
	MergeViewParamsEpic,
	UsageGoogleTagManagerEpic,
	UsagePushPathChangeToGTMDataLayer,
	UsagePushEventsToGTMDataLayer,
	UsageTrackPendoIOEpic,
);
